import { apiRequest } from '@/utils/api-request';
import { Org } from '@/types';

export const getAllOrgs = async () => {
  const response = await apiRequest<Org[]>({
    url: `/organizations/me`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to get all orgs',
      data: response.data,
    };
  }

  return response;
};
